// extracted by mini-css-extract-plugin
module.exports = {"mainWrapper":"SystemDetailsField__mainWrapper___2fwHZ","label":"SystemDetailsField__label___6IWKJ"};